import Axios from 'Helpers/axios';

const fetchFcmRegister = async (params) => {
	try {
		const result = await Axios({
			method: 'POST',
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fcm/register`,
			headers: {
				authorization: params.authorization,
			},
			data: params.body,
		});

		return result;
	} catch (error) {
		throw new Error('Error Something');
	}
};

export default fetchFcmRegister;
